module.exports = __webpack_public_path__ + "static/media/Yanma_gaussian2.0cd82d6b.png";